export function resolveDefaultCampaignAudienceId(audiences) {
  const eligible = (audiences || []).filter(audience => audience && !audience.isDeleted)
  const everyoneAudience = eligible.find(
    audience => audience.name?.trim().toLowerCase() === 'everyone'
  )

  return everyoneAudience?.id
}

export function hasMeaningfulCutoffDate(deliveryFinishDate) {
  if (!deliveryFinishDate) {
    return false
  }

  const parsed = new Date(deliveryFinishDate)
  return !Number.isNaN(parsed.getTime()) && parsed.getFullYear() > 1
}
